<template lang="html">
  <div class="timeline-content">
    <h4 class="row between">
      <span>{{entry.title}}</span>
    </h4>
    <a :href="entry.link" target="_blank" class="fade small" v-if="entry.company">@{{entry.company}}</a>
    <p>{{entry.content}}</p>
    <div class="row between wrap small fade gutterize-x0-5">
      <div class="row middle dates" v-if="entry.date && entry.date.length">
        <div v-for="date in entry.date">{{date | moment(entry.format || 'MMM YYYY')}}</div>
      </div>
      <div v-if="entry.location" class="row middle">
        <i class="fa fa-map-marker" style="margin-right: 5px;"></i>
        <div>{{entry.location}}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    entry: {
      type: Object,
      required: true
    }
  }
};
</script>

<style scoped lang="scss">
@import "../../styles/base/_colors";
a {
  color: $primary;
}
</style>
